import { Paper } from "@mui/material";

import { useGetAllProjectPpQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { associatedEvaluationsColumns } from "./AssociatedEvaluations.columns";

const AssociatedEvaluationsTable = ({ id }: { id: number | string }) => {
  const { data: associatedEvaluations = [], isLoading } =
    useGetAllProjectPpQuery(id);

  return (
    <Paper
      elevation={1}
      sx={{
        overflowX: "auto",
        margin: "0",
        padding: 0,
      }}
    >
      <DefaultDataGrid
        columns={associatedEvaluationsColumns}
        rows={associatedEvaluations}
        getRowId={(row) => row.product__v_id}
        loading={isLoading}
        showToolbar={false}
        localeText={{
          noRowsLabel: "No Associated Evaluations Found ", // Custom message
        }}
      />
    </Paper>
  );
};

export default AssociatedEvaluationsTable;
